import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatHint, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  NgxMatDatepickerActions,
  NgxMatDatepickerApply,
  NgxMatDatepickerInput,
  NgxMatDatetimepicker
} from '@ngxmc/datetime-picker';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { toLocalDate, toUTCString } from '../../../../../config/date-adapter/date-formatter';
import { CustomFieldTypePipe } from '../../../pipes/custom-field-type.pipe';

@Component({
  selector: 'app-custom-field-datepicker',
  standalone: true,
  templateUrl: './custom-field-datepicker.component.html',
  imports: [
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    NgxMatDatepickerInput,
    MatDatepickerToggle,
    NgxMatDatetimepicker,
    NgxMatDatepickerActions,
    MatButton,
    MatSuffix,
    NgxMatDatepickerApply,
    FormsModule,
    MatHint,
    CustomFieldTypePipe
  ],
  styleUrl: './custom-field-datepicker.component.scss'
})
export class CustomFieldDatepickerComponent implements OnChanges {
  @Input() group: FormGroup | null = null;
  @Input() showHint = false;

  value: Date | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['group']) {
      const value = this.group?.get('value')?.value as string;
      this.value = toLocalDate(value);
    }
  }

  setValue(date: Date) {
    this.group?.get('value')?.setValue(toUTCString(date));
  }
}
